import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { PickerPage } from "@/features/cli-picker/PickerPage";

const pickerSearchSchema = z.object({
  token: z.string().optional(),
});

// Opened by `wonda transitions run --picker` with a session token. The bare
// page is retired (server/middleware/retired-pages.ts 301s it to /); this
// covers client-side navigation the same way.
export const Route = createFileRoute("/_landing/cli-picker")({
  validateSearch: zodValidator(pickerSearchSchema),
  beforeLoad: ({ search }) => {
    if (!search.token) throw redirect({ to: "/", statusCode: 301 });
  },
  head: () => ({ meta: [{ name: "robots", content: "noindex,nofollow" }] }),
  component: CliPickerRoute,
});

function CliPickerRoute() {
  const { token } = Route.useSearch();
  return token ? <PickerPage token={token} /> : null;
}
